'use client';
import type { ReadonlyURLSearchParams } from 'next/navigation';
import type { FlexibleFormVariant } from './FlexibleFormBase';
import { createWidgetFormVariantOverrides } from './WidgetForm';
import { getSmsOptInCheckboxAdditionalProps, getSmsOptInCheckboxClickHandler } from './flexibleFormShared';
import { EMAIL_HANDOFF_FORM_TYPE } from './emailHandoffConfig';
import { isValidEmailHandoff } from './emailHandoffValidation';

interface FlexibleFormTypeVariantOverridesArgs {
    asset: SiteFlexibleForm;
    searchParams: ReadonlyURLSearchParams | null;
    identityId?: string;
}

const SMS_OPT_IN_TRACKING_PARAMS: Array<[param: string, fieldName: string]> = [
    ['atok', 'atok'],
    ['utm_source', 'utmSource'],
    ['utm_medium', 'utmMedium'],
    ['utm_campaign', 'utmCampaign'],
    ['utm_content', 'utmContent'],
];

function createSmsOptInVariantOverrides(
    searchParams: ReadonlyURLSearchParams | null,
    identityId?: string,
): Partial<FlexibleFormVariant> {
    const extraHiddenFields: HiddenFormField[] = [];

    SMS_OPT_IN_TRACKING_PARAMS.forEach(([param, fieldName]) => {
        const value = searchParams?.get(param);
        if (value) {
            extraHiddenFields.push({ name: fieldName, value });
        }
    });

    if (identityId) {
        extraHiddenFields.push({ name: 'identityId', value: identityId });
    }

    return {
        extraHiddenFields,
        getCheckboxClickHandler: getSmsOptInCheckboxClickHandler,
        getCheckboxAdditionalProps: getSmsOptInCheckboxAdditionalProps,
        passCheckboxRequired: true,
    };
}

export function createFlexibleFormTypeVariantOverrides({
    asset,
    searchParams,
    identityId,
}: FlexibleFormTypeVariantOverridesArgs): Partial<FlexibleFormVariant> {
    const formType = asset.fields.type.toLowerCase();

    if (formType === EMAIL_HANDOFF_FORM_TYPE) {
        return { emailValidator: isValidEmailHandoff };
    }

    if (formType === 'widgetform-nflsignup') {
        return createWidgetFormVariantOverrides(asset);
    }

    if (formType === 'web_standalone_page') {
        return createSmsOptInVariantOverrides(searchParams, identityId);
    }

    return {};
}
